// @flow
import React from 'react'
import { imagePath } from 'frontend_core/dist/helpers/image'
import ErrorLayout from 'components/layouts/ErrorLayout'
import { connect } from 'react-redux'
import { graphql, gql } from 'react-apollo'
import { viewerFragment, companyFragment } from 'fragments'

function ErrorContainer(props) {
  const title = i18n.t(`error.${props.status}.title` || 'error.default.title')
  const description =
    i18n.t(`error.${props.status}.description`) ||
    i18n.t('error.default.description')
  const errorType =
    props.status === 404 || props.status === '404' ? '404' : 'other'
  const image = imagePath(`business/error/error_${errorType}.png`)
  const imageClassName = `error__main-visual-${errorType}`

  return (
    <ErrorLayout {...props}>
      <div className="error">
        <div className="error__main page__stripes">
          <img src={image} className={imageClassName} role="presentation" />
          <h1 className="error__title">{title}</h1>
          <p className="error__message">{description}</p>
          <a href="/" className="button-stay-blue error__button">
            {i18n.t('page.error.buttonToTop')}
          </a>
        </div>
      </div>
    </ErrorLayout>
  )
}
const withData = graphql(
  gql`{
  viewer {
    ${viewerFragment}
    companies {
      results {
        ... on Company {
          ${companyFragment}
        }
      }
    }
  }
}`,
  { options: { notifyOnNetworkStatusChange: true } },
)(ErrorContainer)

function mapStateToProps(state) {
  return state
}
export default connect(mapStateToProps)(withData)
